export const ALPHABET_COLORS = {
    a: 'FC7960',
    b: 'ED5C88',
    c: 'C866D1',
    d: '7B73E6',
    e: '7B73E6',
    f: '4C81F5',
    g: '4F9DFF',
    h: '38B8FF',
    i: '38B8FF',
    j: '4ACF89',
    k: '4ACF89',
    l: 'F7B500',
    m: 'FF9240',
    n: 'FF9240',
    o: 'FC7960',
    p: 'FC7960',
    q: '969FA3',
    r: '5E6061',
    s: '7B73E6',
    t: '7B73E6',
    u: '7B73E6',
    v: 'C866D1',
    w: '969FA3',
    x: '38B8FF',
    y: 'B58272',
    z: '4ACF89',

    1: 'FC7960',
    2: 'ED5C88',
    3: 'C866D1',
    4: '7B73E6',
    5: '7B73E6',
    6: '4C81F5',
    7: '4F9DFF',
    8: '38B8FF',
    9: '38B8FF',
    0: '4ACF89'
}

export function alphabetToColor(colorLetter: string){
    if (colorLetter.match(/[^a-z0-9]/)) {
        colorLetter = 'a'; // not latin / digit... set to default "a" potom nado pomenayt' na raznie simvoli konechno
    }
    // @ts-ignore
    return "#" + ALPHABET_COLORS[colorLetter];
}